import service from '@/utils/server';

const modName='/transport/appointment/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//初始化新增预约装车
export const addInitPage = data => {
  return service({
    url: modName + 'addInitPage',
    method: 'post',
    data
  });
};

//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//初始化新增预约装车
export const submit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

//新增车牌号
export const saveTruckData = data => {
  return service({
    url: modName + 'truckAdd',
    method: 'post',
    data
  });
};

//新增司机方法
export const saveDriverData = data => {
  return service({
    url: modName + 'driverAdd',
    method: 'post',
    data
  });
};

//文件上传路径
export const uploadUrl = () => {
  return `${process.env.BASE_URL}${modName}uploadTransportFile`;
};

//基本信息
export const orderBasicDetailsInfo = data => {
  return service({
    url: modName + 'orderBasicDetailsInfo',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/page/transport/appointment/api/index.js